const WORDS_PER_MINUTE = 200;

type RichTextNode = {
  text?: string | null;
};

type ContentBlock = {
  body_content?: RichTextNode[] | null;
};

export function getReadingTimeFromBlocks(blocks: ContentBlock[] | null | undefined): string {
  const wordCount = (blocks ?? [])
    .flatMap((block) => block.body_content ?? [])
    .reduce((sum, node) => {
      const words = node.text?.trim().split(/\s+/).filter(Boolean).length ?? 0;
      return sum + words;
    }, 0);

  const minutes = Math.max(1, Math.round(wordCount / WORDS_PER_MINUTE));
  return `${minutes} min read`;
}
